import React, { useEffect, useState } from 'react';
import backgroundImage from 'assests/logos/background.png'; // Memperbaiki path untuk background image
import 'animate.css';
import { useNavigate } from 'react-router-dom';
import postPayment from 'routes/api/postPayment';

const CheckOut = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [validDate, setValidDate] = useState('');
  const [CVV, setCVV] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const icNo = localStorage.getItem('ICNO');
  const token = localStorage.getItem('token');
  const url = localStorage.getItem('api_URL');
  const room = JSON.parse(localStorage.getItem('room'));

  const checkInDate = new Date(localStorage.getItem('date-reservation'));
  const tariff = JSON.parse(localStorage.getItem('rate'))[0];

  const formattedCheckInDate = `${new Date(checkInDate).getFullYear()}-${String(checkInDate.getMonth() + 1).padStart(2, '0')}-${String(checkInDate.getDate()).padStart(2, '0')}`;

  const user = JSON.parse(localStorage.getItem('user'));

  const leftDate = new Date(
    new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(
      new Date(
        new Date(checkInDate).getFullYear(),
        new Date(checkInDate).getMonth(),
        new Date(checkInDate).getDate() + 1
      )
    )
  );

  const formatedCheckOutDate = `${new Date(leftDate).getFullYear()}-${String(leftDate.getMonth() + 1).padStart(2, '0')}-${String(leftDate.getDate()).padStart(2, '0')}`;

  const nav = useNavigate();

  useEffect(() => {
    const { firstName, lastName, phoneNumber, email } = JSON.parse(
      localStorage.getItem('user')
    );
    setFirstName(firstName);
    setLastName(lastName);
    setPhoneNumber(phoneNumber);
    setEmail(email);
  }, []);

  const handleBack = () => nav('/orderDetails');
  const handlePaymentBack = () => setPaymentMethod('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      firstName: user.firstName,
      lastName: user.lastName,
      birthDate: user.dateOfBirth,
      address: user.address,
      countryID: user.country,
      city: user.city,
      email: user.email,
      dateArrival: formattedCheckInDate,
      depatureDate: formatedCheckOutDate,
      phone: user.phoneNumber,
      roomtypeID: room.roomID,
      tariffId: tariff.tariffID,
      rateAmount: localStorage.getItem('price'),
    };

    const response = await postPayment(url, icNo, token, formData);

    localStorage.setItem('book_id', response.data[0].Data);

    if (response.data[0].Status == '200') {
      nav('/paymentSuccessfull');
    }

    // Add your form submission logic here
  };

  return (
    <div
      className="bg-brand min-h-screen text-slate-1000 flex flex-col bg-cover bg-center bg-no-repeat animate-[fadeInBackground_1s_ease-in-0ut]"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <style>
        {`
          @keyframes  {
            from { opacity: 0; }
            to { opacity: 1; }
          }
        `}
      </style>
      <h1 className="text-[#004AAD] font-bold text-2xl ml-10">CHECKOUT</h1>
      <div className="flex">
        <div className="hero-content__container flex flex-col container mx-auto px-2 md:px-0 mt-1 ml-10 h-auto">
          <div className="hero-content__text">
            <h3 className="text-3xl font-medium text-center border-2 border-[#004AAD] bg-[whitesmoke] opacity-80 rounded-lg p-5 min-w-[25%]">
              <button
                className="px-9 py-2 rounded-full bg-[#004AAD] text-[#D9D9D9] font-bold text-lg w-3/4"
                disabled
              >
                Contact Detail E-Voucher
              </button>
              <form className="max-w-[1000px] mx-auto mt-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="mb-4">
                    <label
                      htmlFor="first-name"
                      className="block text-left text-base font-bold text-gray-700"
                    >
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="first-name"
                      name="first-name"
                      className="mt-1 p-2 w-full border border-gray-300 rounded-md text-sm"
                      placeholder="Enter your first name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      disabled
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="phone"
                      className="block text-left text-base font-bold text-gray-700"
                    >
                      Phone Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="mt-1 p-2 w-full border border-gray-300 rounded-md text-sm"
                      placeholder="Enter your phone number"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      disabled
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="last-name"
                      className="block text-left text-base font-bold text-gray-700"
                    >
                      Last Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="last-name"
                      name="last-name"
                      className="mt-1 p-2 w-full border border-gray-300 rounded-md text-sm"
                      placeholder="Enter your last name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      disabled
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="email"
                      className="block text-left text-base font-bold text-gray-700"
                    >
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      className="mt-1 p-2 w-full border border-gray-300 rounded-md text-sm"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled
                    />
                  </div>
                </div>

                <div className="border-2 border-[#004AAD] min-h-[50%] rounded-lg p-5 mt-6 bg-whitesmoke opacity-80 text-lg text-center flex flex-col justify-between">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b-2 border-black">
                        <th className="text-left">Description</th>
                        <th>Qty</th>
                        <th>Night/Hour</th>
                        <th className="text-right">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-left">{room.roomTypeName}</td>
                        <td>1</td>
                        <td>{localStorage.getItem('durationStay')}</td>
                        <td className="text-right">
                          {new Intl.NumberFormat('ja-JP', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                          }).format(localStorage.getItem('price'))}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="text-left">
                    <h2 className="text-red-500 text-sm">
                      {`${new Intl.DateTimeFormat('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      }).format(new Date(checkInDate))}
                      - ${new Intl.DateTimeFormat('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      }).format(
                        new Date(
                          new Date(checkInDate).getFullYear(),
                          new Date(checkInDate).getMonth(),
                          new Date(checkInDate).getDate() + 1
                        )
                      )}`}
                    </h2>
                    <div className="flex justify-between">
                      <h2 className="font-bold text-xl">TOTAL</h2>
                      <h2 className="font-bold text-xl">
                        {new Intl.NumberFormat('ja-JP', {
                          style: 'currency',
                          currency: 'IDR',
                          minimumFractionDigits: 0,
                        }).format(localStorage.getItem('price'))}
                      </h2>
                    </div>
                  </div>
                </div>
              </form>
              <button
                className="bg-red-500 text-white font-bold text-lg rounded-full w-full mt-2 py-2 "
                onClick={handleBack}
              >
                BACK
              </button>
            </h3>
          </div>
        </div>

        <div className="hero-content__container flex flex-col container mx-auto px-2 md:px-0 mr-6 ml-10 font-bold">
          <div className="border-2 border-[#004AAD] bg-[whitesmoke] opacity-80 rounded-lg px-3 flex flex-col items-center text-lg min-h-full justify-between">
            <button
              className="px-9 py-2 rounded-full bg-[#004AAD] text-[#D9D9D9] font-bold w-3/4 mt-5"
              disabled
            >
              Payment Methode
            </button>

            {paymentMethod === 'Credit / Debit Card' ? (
              <>
                <button
                  className="my-1 cursor-pointer px-9 py-2 w-3/4 rounded-full border-2 border-[#004AAD] text-[#004AAD]"
                  onClick={() => setPaymentMethod('')}
                >
                  Credit / Debit Card
                </button>
                <form className="w-11/12 mx-auto" onSubmit={handleSubmit}>
                  <label
                    htmlFor="cardNumber"
                    className="block text-left text-base font-bold text-gray-700"
                  >
                    Card Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="cardNumber"
                    name="cardNumber"
                    className="mt-1 p-2 w-full border border-gray-300 rounded-md text-sm mb-2"
                    placeholder="1111 – 2222 – 3333 – 4444"
                    value={cardNumber}
                    onChange={(e) => setCardNumber(e.target.value)}
                  />
                  <div className="flex">
                    <div className="w-1/2 pr-2">
                      <label
                        htmlFor="validDate"
                        className="block text-left text-base font-bold text-gray-700"
                      >
                        Valid Until <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        id="validDate"
                        name="validDate"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md text-sm"
                        value={validDate}
                        onChange={(e) => setValidDate(e.target.value)}
                      />
                    </div>
                    <div className="w-1/2 pl-2">
                      <label
                        htmlFor="CVV"
                        className="block text-left text-base font-bold text-gray-700"
                      >
                        CVV <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        id="CVV"
                        name="CVV"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md text-sm"
                        placeholder="CVV"
                        value={CVV}
                        onChange={(e) => setCVV(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="my-8 flex justify-between">
                    <button
                      className="bg-red-500 text-white font-bold text-lg rounded-full w-1/2 py-2 mr-5"
                      onClick={handlePaymentBack}
                    >
                      BACK
                    </button>
                    <button
                      type="submit"
                      className="bg-green-500 text-white font-bold text-lg rounded-full w-1/2 py-2"
                    >
                      PAYMENT
                    </button>
                  </div>
                </form>
              </>
            ) : paymentMethod === 'Pay At Hotel' ? (
              <>
                <button
                  className="my-1 cursor-pointer px-9 py-2 w-3/4 rounded-full border-2 border-[#004AAD] text-[#004AAD]"
                  onClick={() => setPaymentMethod('')}
                >
                  Pay at Hotel
                </button>
                <form className="w-11/12 mx-auto" onSubmit={handleSubmit}>
                  <p className="mt-4 text-center">
                    You have selected to pay at the hotel Receptionist
                  </p>
                  <p className="mt-4 text-center text-[#004AAD]">
                    {new Intl.NumberFormat('ja-JP', {
                      style: 'currency',
                      currency: 'IDR',
                      minimumFractionDigits: 0,
                    }).format(localStorage.getItem('price'))}
                  </p>
                  <div className="my-8 flex justify-between">
                    <button
                      className="bg-red-500 text-white font-bold text-lg rounded-full w-1/2 py-2 mr-5"
                      onClick={handlePaymentBack}
                    >
                      BACK
                    </button>
                    <button
                      type="submit"
                      className="bg-green-500 text-white font-bold text-lg rounded-full w-1/2 py-2"
                    >
                      PAYMENT
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <>
                <button
                  className="my-1"
                  onClick={() => setPaymentMethod('Credit / Debit Card')}
                >
                  Credit Card / Debit Card
                </button>
                <button className="my-1">Bank Transfer</button>
                <button className="my-1">Virtual Account</button>
                <button className="my-1">Qris</button>
                <button className="my-1">Gopay</button>
                <button className="my-1">E-wallet</button>
                <button
                  className="my-1"
                  onClick={() => setPaymentMethod('Pay At Hotel')}
                >
                  Pay at Hotel
                </button>
                <button
                  type="submit"
                  className="bg-gray-400 text-white font-bold text-lg rounded-full w-full my-4 py-2"
                  disabled
                >
                  PAYMENT
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckOut;
